import { DeprecatedPhoneNumberInput } from "common/form/inputs/phone/number";
import { DeprecatedFieldWrapper } from "common/form/enhancers/redux_form_field_wrapper";

/** @deprecated - please use components in common/core/form */
export const DeprecatedPhoneNumberField = DeprecatedFieldWrapper(DeprecatedPhoneNumberInput);
